"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuspenseFactoryContext = exports.SuspenseFactoryContainer = exports.SuspenseFactoryContext = exports.SuspenseFactoryManager = exports.CommonSuspenseType = void 0;
var react_1 = __importStar(require("react"));
var AcornGridSuspense_1 = require("./AcornGridSuspense");
var AcornPrimaryContentSuspense_1 = require("./AcornPrimaryContentSuspense");
var AcornTableSuspense_1 = require("./AcornTableSuspense");
var CommonSuspenseType;
(function (CommonSuspenseType) {
    CommonSuspenseType["PrimaryContent"] = "PrimaryContent";
    CommonSuspenseType["SecondaryContent"] = "SecondaryContent";
    CommonSuspenseType["Table"] = "Table";
    CommonSuspenseType["Grid"] = "Grid";
    CommonSuspenseType["Panel"] = "Panel";
})(CommonSuspenseType = exports.CommonSuspenseType || (exports.CommonSuspenseType = {}));
var SuspenseFactoryManager = /** @class */ (function () {
    function SuspenseFactoryManager(suspenseFactories) {
        Object.defineProperty(this, "suspenseFactories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: suspenseFactories
        });
    }
    Object.defineProperty(SuspenseFactoryManager.prototype, "getSuspenseComponent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            if (this.suspenseFactories[type]) {
                return this.suspenseFactories[type];
            }
            // If we don't have a matching suspense wrappers - no big deal, just return
            // a react fragment to essentially 'do nothing'
            return react_1.default.Fragment;
        }
    });
    return SuspenseFactoryManager;
}());
exports.SuspenseFactoryManager = SuspenseFactoryManager;
/**
 * A context for supplying suspense components for various purposes.
 *
 * Note that the perhaps more obvious name `SuspenseContext` was avoided here
 * as it would probably convey some notion of this context tracking the state
 * of the suspense activity. It does not - it only is a source for retrieving
 * the correct suspense component for a variety of different scenarios.
 */
exports.SuspenseFactoryContext = react_1.default.createContext(new SuspenseFactoryManager({}));
var SuspenseFactoryContainer = function (props) {
    var _a;
    var manager = new SuspenseFactoryManager(__assign((_a = { default: undefined }, _a[CommonSuspenseType.PrimaryContent] = AcornPrimaryContentSuspense_1.AcornPrimaryContentSuspense, _a[CommonSuspenseType.Table] = AcornTableSuspense_1.AcornTableSuspense, _a[CommonSuspenseType.Grid] = AcornGridSuspense_1.AcornGridSuspense, _a), props.suspenseFactories));
    return react_1.default.createElement(exports.SuspenseFactoryContext.Provider, { value: manager }, props.children);
};
exports.SuspenseFactoryContainer = SuspenseFactoryContainer;
var useSuspenseFactoryContext = function () {
    return react_1.useContext(exports.SuspenseFactoryContext);
};
exports.useSuspenseFactoryContext = useSuspenseFactoryContext;
//# sourceMappingURL=SuspenseFactoryContext.js.map